<app-dialog-header [title]="'ENGAGE.BUTTONS.ADD_EXPERIENCE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <mat-form-field class="w-100-p">
        <mat-label>{{ 'ENGAGE.EXPERIENCE.TITLE.SINGULAR' | translate }}</mat-label>
        <mat-select [formControl]="experienceCtrl">
            <mat-optgroup *ngFor="let experience of experiences; let j = index">
                <mat-option [class.selected]="experience.open" [value]="experience">
                    {{ experience.name }}
                </mat-option>
            </mat-optgroup>
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.ADD'" [disabled]="!experienceCtrl.value" (onClick)="save.emit(experienceCtrl.value)"></app-flat-button>
</div>
